<template>
  <div>
    <el-popover
       ref="popoverBmiClasification"
       placement="bottom-start"
       popper-class="el-popover--bmi-info"
       width="300"
       trigger="click">
      <div class="el-popover__title"><strong>{{ $t('label.bmi_clasification') }}</strong></div>
      <ul class="nuttrema-iconica-bmi--clasification">
        <li :class="{ 'is-active': bmiCategory.code === 'under_weight' }">
          <span class="category-label">{{ $t('label.under_weight') }}</span>
          <span class="tag tag--bmi-under_weight">
            {{ $t('label.less_than') }} 18.5
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'healthy_weight' }">
          <span class="category-label">{{ $t('label.healthy_weight') }}</span>
          <span class="tag tag--bmi-healthy_weight">
            {{ $t('label.beetween') }} 18.5 - 25
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'over_weight_i' }">
          <span class="category-label">{{ $t('label.over_weight_i') }}</span>
          <span class="tag tag--bmi-over_weight_i">
            {{ $t('label.beetween') }} 25 - 27
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'over_weight_ii' }">
          <span class="category-label">{{ $t('label.over_weight_ii') }}</span>
          <span class="tag tag--bmi-over_weight_ii">
            {{ $t('label.beetween') }} 27 - 30
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'obesity_i' }">
          <span class="category-label">{{ $t('label.obesity_i') }}</span>
          <span class="tag tag--bmi-obesity_i">
            {{ $t('label.beetween') }} 30 - 35
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'obesity_ii' }">
          <span class="category-label">{{ $t('label.obesity_ii') }}</span>
          <span class="tag tag--bmi-obesity_ii">
            {{ $t('label.beetween') }} 35 - 40
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'severely_obese' }">
          <span class="category-label">{{ $t('label.severely_obese') }}</span>
          <span class="tag tag--bmi-severely_obese">
            {{ $t('label.beetween') }} 40 - 50
          </span>
        </li>
        <li :class="{ 'is-active': bmiCategory.code === 'morbidly_obese' }">
          <span class="category-label">{{ $t('label.morbidly_obese') }}</span>
          <span class="tag tag--bmi-morbidly_obese">
            {{ $t('label.greater_than') }} 50
          </span>
        </li>
      </ul>
    </el-popover>
    <el-tooltip
         placement="top"
         trigger="hover"
        :content="bmiCategory.name"
        :open-delay="500">
      <div
         class="nuttrema-iconica-bmi"
         v-popover:popoverBmiClasification
        :class="[bmiClass]"
        :style="style.main"
        @mouseover="$emit('hover')"
        @mouseclick="$emit('click')">
        <span class="txt">
          <span :style="style.fontSizeText">{{ bmiValue | number-format(0) }}</span>
        </span>
        <span class="bmi-info">
          <span class="tbl">
            <span class="tc">
              <span class="description" :style="style.fontSizeDescription">{{ $t('label.bmi') }}</span>
              <span class="value" :style="style.fontSizeValue">{{ bmiValue | number-format(2) }}</span>
            </span>
          </span>
        </span>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
/* eslint-disable object-shorthand */
import { get, isEmpty, has } from 'lodash';

export default {
  name: 'nuttrema-iconica-bmi',
  props: {
    measurement: {
      required: true,
      default: null,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
  data() {
    return {
      bmiClass: null,
      bmiValue: null,
      bmiCategory: null,
      sizes: {
        small: {
          width: '1.85em',
          fontSize: '1.15rem',
        },
        normal: {
          width: '2.8em',
          fontSize: {
            text: '1rem',
            value: '0.85rem',
            description: '0.7rem',
          },
        },
        large: {
          width: '3.1em',
          fontSize: '1.4rem',
        },
      },
      style: {},
    };
  },
  methods: {
    getBMIClass() {
      return get(this.measurement, 'TrackingGroups.body_mass_index_group.MeasurementTypes.body_mass_index_level.Measurement.value_text') || null;
    },
    getBMIValue() {
      return get(this.measurement, 'TrackingGroups.body_mass_index_group.MeasurementTypes.body_mass_index.Measurement.value') || 0;
    },
    getBMICategory() {
      const notFound = { name: this.$t('label.not_found') };
      const bodyMassIndexCategory = get(this.measurement, 'TrackingGroups.body_mass_index_group.MeasurementTypes.body_mass_index_level.Measurement.value_text') || false;
      const bodyMassIndexCategoryDescription = get(this.measurement, 'TrackingGroups.body_mass_index_group.MeasurementTypes.body_mass_index_level.MeasurementTypeOptions') || false;
      return bodyMassIndexCategory && !isEmpty(bodyMassIndexCategoryDescription) ? bodyMassIndexCategoryDescription[bodyMassIndexCategory] : notFound;
    },
    getStyle() {
      const size = this.sizes[this.size];
      return {
        main: `width: ${size.width}; max-width: ${size.width}; height: ${size.width}; max-height: ${size.width};`,
        fontSizeText: has(size, 'fontSize.text') ? `font-size: ${size.fontSize.text};` : '',
        fontSizeValue: has(size, 'fontSize.value') ? `font-size: ${size.fontSize.value};` : '',
        fontSizeDescription: has(size, 'fontSize.description') ? `font-size: ${size.fontSize.description};` : '',
        picture: `background-image: url(${this.image})`,
      };
    },
    setData() {
      this.bmiClass = this.getBMIClass();
      this.bmiValue = this.getBMIValue();
      this.bmiCategory = this.getBMICategory();
      this.style = this.getStyle();
    },
  },
  watch: {
    measurement: {
      handler: function () {
        this.setData();
      },
      deep: true,
    },
  },
  created() {
    this.setData();
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/theme/content-colors";
  .nuttrema-iconica-bmi {
    display: block;
    position: relative;
    border-radius: 50%;
    background-color: darken($turquoise, 5%);

    span.txt {
        display: table;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0; left: 0;
        vertical-align: middle;
        text-align: center;
        z-index: 1;
        color: #fff;
        > span, > i {
            display: table-cell;
            vertical-align: middle;
            font-size: 1.25rem;
        }
        > span {
          font-size: 1rem;
          font-weight: 600;
          text-shadow: 0 -1px 0 rgba(0,0,0,0.25);
        }
        > i {
            font-size: 24px;
        }
    }

    span.bmi-info {
      display: none;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      z-index: 1;
      background-color: rgba(0,0,0,0.25);
      left: 0; top: 0;
      > span.tbl {
        display: table;
        width: 100%;
        height: 100%;
        position: absolute;
        color: #fff;
        > span.tc {
          display: table-cell;
          font-weight: 800;
          line-height: 12px;
          padding-top: 0.4em;
          text-align: center;
          vertical-align: top;
          text-shadow: 0 1px solid rgba(0,0,0,0.75);
          > span {
            display: block;
            &.value {
                font-size: 1rem;
                line-height: 1;
            }
            &.description {
                font-weight: 400;
                font-size: 0.9rem;
            }
          }
        }
      }
    }

    &::before {
      display: inline-block;
      content: '';
      width: 130.5%;
      height: 130.5%;
      border-radius: 50%;
      border: 4px solid darken($turquoise, 5%);
      position: absolute;
      left: -14.75%; top: -14.75%;
      z-index: 3;
      opacity: 1;
      -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
    }

    &:hover, &:active, &:focus {
      cursor: pointer;
      &::before { opacity: 1; }
      span.txt { display: none; }
      span.bmi-info {
          z-index: 2;
          display: inline-block;
      }
    }

    &.under_weight {
      background-color: darken($bmi-under-weight, 7%);
      &::before {
        border-color: $bmi-under-weight !important;
      }
    }

    &.healthy_weight {
      background-color: darken($bmi-healthy-weight, 7%);
      &::before {
        border-color: $bmi-healthy-weight !important;
      }
    }

    &.over_weight_i {
      background-color: darken($bmi-over-weight-i, 7%);
      &::before {
        border-color: $bmi-over-weight-i !important;
      }
    }

    &.over_weight_ii {
      background-color: darken($bmi-over-weight-ii, 7%);
      &::before {
        border-color: $bmi-over-weight-ii !important;
      }
    }

    &.obesity_i {
      background-color: darken($bmi-obesity-i, 7%);
      &::before {
        border-color: $bmi-obesity-i !important;
      }
    }

    &.obesity_ii {
      background-color: darken($bmi-obesity-ii, 7%);
      &::before {
        border-color: $bmi-obesity-ii !important;
      }
    }

    &.severely_obese {
      background-color: darken($bmi-severely-obese, 7%);
      &::before {
        border-color: $bmi-severely-obese !important;
      }
    }

    &.morbidly_obese {
      background-color: darken($bmi-morbidly-obese, 7%);
      &::before {
        border-color: $bmi-morbidly-obese !important;
      }
    }

  }
  .nuttrema-iconica-bmi--clasification {
    > li {
      width: 100%;
      margin: 0.25em 0;
      line-height: 1.75;
      display: inline-block;
      &.is-active {
        .category-label {
          font-weight: 600;
          text-decoration: underline;
        }
      }
      .tag {
        width: 50%;
        color: #fff;
        float: right;
        font-weight: 500;
        text-shadow: 0 -1px 0 rgba(0,0,0,0.25);

        &.tag--bmi-under_weight {
          background-color: #8694ce;
        }

        &.tag--bmi-healthy_weight {
          background-color: #5cbaaf;
        }

        &.tag--bmi-over_weight_i {
          background-color: #d1a864;
        }

        &.tag--bmi-over_weight_ii {
          background-color: #a87d36;
        }

        &.tag--bmi-obesity_i {
          background-color: #e46e64;
        }

        &.tag--bmi-obesity_ii {
          background-color: #c2463c;
        }

        &.tag--bmi-severely_obese {
          background-color: #9f261d;
        }

        &.tag--bmi-morbidly_obese {
          background-color: #700049;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-iconica-bmi.vue